import classnames from 'classnames';
import React from 'react';

import cs from 'app/components/Sidebar/styles.module.scss';

export interface SidebarToolbarProps {
  /** Leading control, typically a select-all checkbox. */
  leading?: React.ReactNode;
  /** Bold summary of what the list below is showing. */
  label?: React.ReactNode;
  /** Sort / filter controls, pushed to the trailing edge. */
  actions?: React.ReactNode;
  className?: string;
}

/** Persistent bar between a panel's header and its scrolling list. */
export const SidebarToolbar: React.FC<SidebarToolbarProps> = ({
  leading,
  label,
  actions,
  className,
}) => (
  <div className={classnames(cs.toolbar, className)}>
    {leading && <span className={cs.toolbarLeading}>{leading}</span>}
    {label && <span className={cs.toolbarLabel}>{label}</span>}
    {actions && <span className={cs.toolbarActions}>{actions}</span>}
  </div>
);
